import CONFIG from "config/config";

// Mirrors oppizi-platform's `apiClient.userAuth` (src/Module/Api/Client.js:1046).
// REST endpoint, not GraphQL — kept inside /graphQL/ for path consistency
// with the other signup helpers.

export type UserAuthResponse = {
  user?: { id: number | string; email: string; role: string; firstName?: string; lastName?: string };
  apiKey?: string;
  countryName?: string;
  countryCode?: string;
};

export const userAuth = async (email: string, password: string): Promise<UserAuthResponse> => {
  const response = await fetch(`${CONFIG.API_BASE_URL}/auth`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
    // Cross-origin (builder:3006 → api:5000) — without `credentials: 'include'`
    // the browser ignores the Set-Cookie header in the response, so the
    // platform never sees the auth cookie when we hand off the session.
    credentials: "include",
  });
  if (!response.ok) {
    let message = `Login failed (${response.status})`;
    try {
      const body = await response.json();
      if (body?.message) message = body.message;
      else if (body?.error) message = body.error;
    } catch {
      /* keep default */
    }
    throw new Error(message);
  }
  return (await response.json()) as UserAuthResponse;
};
